export type UploadObjectS3Options = {
  uploadUrl: string;
  blob: Blob;
  headers?: Record<string, string>;
  onProgress?: (event: ProgressEvent) => void;
  signal?: AbortSignal;
};

// axios don't upload the file, so we are using the XMLHttpRequest
// https://github.com/axios/axios/issues/3442
export const uploadObjectToS3 = ({
  blob,
  uploadUrl,
  headers,
  onProgress,
  signal,
}: UploadObjectS3Options) => {
  return new Promise(function (resolve, reject) {
    const xhr = new XMLHttpRequest();

    xhr.open('PUT', uploadUrl);

    xhr.onerror = (err): void => {
      reject({
        status: xhr.status,
        statusText: xhr.statusText,
        ...err,
      });
    };

    xhr.upload.onerror = (arg): void => {
      console.error('ERR upload error', arg);
    };

    xhr.upload.onprogress = (evt): void => {
      console.log(Math.round((evt.loaded / evt.total) * 100) + '%');

      onProgress?.(evt);
    };

    xhr.onload = (): void => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(xhr.response);
      } else {
        reject({
          status: xhr.status,
          statusText: xhr.statusText,
        });
      }
    };

    signal?.addEventListener('abort', () => {
      xhr.abort();
      // reject();
    });

    if (headers) {
      Object.entries(headers).forEach(([key, value]) => {
        xhr.setRequestHeader(key, value);
      });
    }

    xhr.send(blob);
  });
};
